import { SecurityType, useFavoriteSecurities } from '@talos/kyoko';
import type { IDockviewPanelProps } from 'dockview';
import { useCallback } from 'react';
import type { WatchlistPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import { Watchlist } from '../../../Watchlist';

export function WatchlistPanel({ api, params }: IDockviewPanelProps<WatchlistPanelConfig>) {
  const setShowOnlyFavorites = useCallback(
    (value: WatchlistPanelConfig['showOnlyFavorites']) => {
      api.updateParameters({
        showOnlyFavorites: value,
      });
    },
    [api]
  );

  const setSecurityTypes = useCallback(
    (value: WatchlistPanelConfig['securityTypes']) => {
      api.updateParameters({
        securityTypes: value,
      });
    },
    [api]
  );

  const setFilteredCurrencies = useCallback(
    (value: WatchlistPanelConfig['filteredCurrencies']) => {
      api.updateParameters({
        filteredCurrencies: value,
      });
    },
    [api]
  );

  const { setFavoriteSecurities, favoriteSecurities } = useFavoriteSecurities();

  return (
    <Panel panelApi={api} data-testid="watchlist-panel">
      <Watchlist
        {...params}
        securityTypes={params.securityTypes ?? SecurityType.Spot}
        setShowOnlyFavorites={setShowOnlyFavorites}
        setSecurityTypes={setSecurityTypes}
        setFilteredCurrencies={setFilteredCurrencies}
        setFavoriteSecurities={setFavoriteSecurities}
        favoriteSecurities={favoriteSecurities}
      />
    </Panel>
  );
}
